import React, { useState, useRef, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { IconPlus, IconSearch, IconChevronDown, IconX, IconBrain  } from '@tabler/icons-react'
import { SET_COMPONENT_NODES } from '../../store/actions'
import { Button } from '@/components/ui/button'
import ToolEditModal from '../tools/ToolEditModal'
import { RootState } from '@/store'



interface AddNodesProps {
    nodesData: any[];
    node: any;
    setAddNode: (value: boolean) => void;
    getAllNodeOnclick: () => void;
}

const AddNodes: React.FC<AddNodesProps> = ({ nodesData, node, setAddNode, getAllNodeOnclick }) => {
    const customization = useSelector((state: RootState) => state.customization)
    const dispatch = useDispatch()

    const [searchValue, setSearchValue] = useState('')
    const [nodes, setNodes] = useState<any>({})
    const [open, setOpen] = useState(false)
    const [categoryExpanded, setCategoryExpanded] = useState<{ [key: string]: boolean }>({})
    const [openCreateNodeModal, setOpenCreateNodeModal] = useState(false)

    const anchorRef = useRef<any>(null)
    const prevOpen = useRef(open)
    const ps = useRef()

    const scrollTop = () => {
        const curr = ps.current
        // if (curr) {
        //     curr.scrollTop = 0
        // }
    }

    const handleNodeAI = () => {
        setOpenCreateNodeModal(true)

    }

    const getSearchedNodes = (value: string) => {
        const passed = nodesData.filter((nd) => {
            const passesQuery = nd.name.toLowerCase().includes(value.toLowerCase())
            const passesCategory = nd.category.toLowerCase().includes(value.toLowerCase())
            return passesQuery || passesCategory
        })
        return passed
    }

    const filterSearch = (value: string) => {
        setSearchValue(value)
        setTimeout(() => {
            if (value) {
                const returnData = getSearchedNodes(value)
                groupByCategory(returnData, true)
                scrollTop()
            } else if (value === '') {
                groupByCategory(nodesData, false)
                scrollTop()
            }
        }, 500)
    }

    const groupByCategory = (nodes: any[], isFilter: boolean) => {
        const accordianCategories: { [key: string]: boolean } = {}
        const result = nodes.reduce((r, a) => {
            r[a.category] = r[a.category] || []
            r[a.category].push(a)
            accordianCategories[a.category] = isFilter ? true : false
            return r
        }, Object.create(null))
        setNodes(result)
        setCategoryExpanded(accordianCategories)
    }

    const handleAccordionChange = (category: string) => {
        const accordianCategories = { ...categoryExpanded }
        accordianCategories[category] = !accordianCategories[category]
        setCategoryExpanded(accordianCategories)
    }

    const handleClose = (event: React.MouseEvent) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return
        }
        setOpen(false)
    }

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen)
    }

    const onDragStart = (event: React.DragEvent, node: any) => {
        event.dataTransfer.setData('application/reactflow', JSON.stringify(node))
        event.dataTransfer.effectAllowed = 'move'
    }

    useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus()
        }

        prevOpen.current = open
    }, [open])

    useEffect(() => {
        if (node) setOpen(false)
    }, [node])

    useEffect(() => {
        if (nodesData) {
            groupByCategory(nodesData, false)
            dispatch({ type: SET_COMPONENT_NODES, componentNodes: nodesData })
        }
    }, [nodesData, dispatch])

    return (
        <>
            {/* <ToolCreateModal
                show={openCreateNodeModal}
                onCancel={() => setOpenCreateNodeModal(false)}
            /> */}

{openCreateNodeModal &&  <ToolEditModal openToolEditModal={openCreateNodeModal} setOpenToolEditModal={setOpenCreateNodeModal} getAllNodeOnclick={getAllNodeOnclick}
/> }
          {/* <div className="flex justify-end">
                <button
                    className="rounded-md mr-1 text-red-500 cursor-pointer"
                    onClick={() => setAddNode(false)}
                >
                    <IconX />
                </button>
            </div>
            */}
            
                <div className="flex flex-row justify-between">
                    <h4 className="text-lg font-semibold">Add Nodes</h4>
                    <div className='flex flex-row gap-2'>
                    <Button size='xs' variant='outline'  onClick={handleNodeAI}>
                    <IconPlus />
                    <span>Custom Node</span>
                    </Button>
                    <Button size='xs' variant='outline'>  <IconBrain size={16}/> </Button>
                   
                    </div>
                </div>
                <div className="relative w-full my-4">
                    <input
                        className="w-full px-6 py-2 border rounded-lg"
                        id="input-search-node"
                        value={searchValue}
                        onChange={(e) => filterSearch(e.target.value)}
                        placeholder="Search nodes"
                    />
                    <div className="absolute inset-y-0 left-0 flex items-center pl-1 pointer-events-none">
                        <IconSearch className="text-gray-500" size="1rem" />
                    </div>
                    {searchValue && (
                        <div
                            className="absolute inset-y-0 right-0 flex items-center pr-3 cursor-pointer text-gray-500 hover:text-gray-900"
                            title="Clear Search"
                            onClick={() => filterSearch('')}
                        >
                            <IconX className="cursor-pointer" size="1rem" />
                        </div>
                    )}
                </div>
                <hr className="my-2" />
            {/* <div className="px-4">
                <button
                    className="w-full py-2 my-2 text-white bg-blue-500 rounded-full cursor-pointer"
                    onClick={handleNodeAI}
                >
                    Add Node Through AI
                </button>
                <hr className="my-2" />
            </div> */}
            <PerfectScrollbar
                style={{ height: '100%', maxHeight: 'calc(100vh - 200px)', overflowX: 'hidden' }}
            >
                <div className="p-4">
                    <div className="w-full max-w-md mx-auto space-y-4">
                        {Object.keys(nodes)
                            .sort()
                            .map((category) => (
                                <div key={category} className="border-gray-200">
                                    <div
                                        className="flex items-center justify-between py-2 cursor-pointer 0"
                                        onClick={() => handleAccordionChange(category)}
                                    >
                                        <h5 className="text-base font-medium">{category}</h5>
                                        <IconChevronDown className={`${categoryExpanded[category] ? 'rotate-180' : ''}`} />
                                    </div>
                                    {categoryExpanded[category] && (
                                        <div className="space-y-2">
                                            {nodes[category].map((node, index) => (
                                                <div key={node.displayName} onDragStart={(event) => onDragStart(event, node)} draggable>
                                                    <div className="flex items-center border rounded-[12px] cursor-move p-2 hover:bg-gray-300">
                                                        <div className="flex-shrink-0 w-12 h-12 bg-white rounded-full">
                                                            <img
                                                                className="object-contain w-full h-full p-2"
                                                                alt={node.displayName}
                                                                src={node.logoUrl}
                                                            />
                                                        </div>
                                                        <div className="ml-2 mb-1">
                                                            <p className="text-base font-medium">{node.displayName}</p>
                                                            <p className="text-sm text-gray-500 font-normal">{node.description}</p>
                                                        </div>
                                                    </div>
                                                    {index === nodes[category].length - 1 ? null : <hr className="my-2" />}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            ))}
                    </div>
                </div>
            </PerfectScrollbar>
        </>
    )
}

AddNodes.propTypes = {
    nodesData: PropTypes.array.isRequired,
    node: PropTypes.object,
    setAddNode: PropTypes.func.isRequired
}

export default AddNodes
